/* eslint-disable */

import Util from '@/assets/libs/util'
import requesModule from '@/assets/libs/requestModule'
import continuaTransacaoTefOBJ from '@/assets/tef/ContinuaTransacaoTefOBJ'
import eventModule from '@/assets/libs/eventModule'
import PaymentController from '@/assets/controllers/PaymentController'
import TefMessageController from '@/assets/controllers/TefMessageController'
import router from '@/router';
import PaymentTimeoutController from '../controllers/PaymentTimeoutController'
import waitForDOMUpdate from '@/assets/libs/waitForDOMUpdate'

const EVENT_CONTINUA_TRANSACAO = '/continue-transaction'
const STOP_TEF_COMMAND = -1
const RETORNO_DLL_FAKE_ANDROID = 10000

let cancelledByUser = false
let alreadyAborted = false
let androidSecondStage = false
let lastCommand = null
let titleReceived = ''
let toContinue = true

const continuaTransacaoTef = async function (valorTotal, IDTIPORECE, CDTIPORECE, DATECANCEL, DOCNUMBER, CDFILIAL, CDCAIXA, isCancelTefOperation = false, saleType, isDigitalWalletPayment = false, isFuncoesAdministrativas = false) {
    cancelledByUser = false
    alreadyAborted = false
    toContinue = true
    try {
        let errorMessage = ''
        let comando = 0
        let tipoCampo = 0
        let tamMinimo = 0
        let tamMaximo = 0
        let bufferParam = ''
        let tamBuffer = 0
        let continua = 0
        let bufferConvertedbkp = ''

        let retornoContinua = null
        // let iterationCounter = 0
        let result = null
        let resetTimeout = false
        let ignoreMessage = false
        PaymentController.setWaitingForData(false)
        do {
            let paramsContinua = {
                command: comando,
                fieldType: tipoCampo,
                minSize: tamMinimo,
                maxSize: tamMaximo,
                bufferParam: bufferParam,
                sizeBuffer: tamBuffer,
                continueCommand: continua
            }

            if (comando !== lastCommand) {
                lastCommand = comando
                PaymentTimeoutController.resetTimeout()
                resetTimeout = true
            }

            if (PaymentTimeoutController.getTimeoutCounter() <= 0) {
                toContinue = true
                ignoreMessage = true
                stopTransactionTef()
            }

            let autoCancelTefTriggered = PaymentController.getAutoCancelTefTriggered()
            if (cancelledByUser || autoCancelTefTriggered || !['Payment', 'Config'].includes(router.currentRoute.name)) {
                if (Util.isAndroidMode() && !alreadyAborted && !androidSecondStage) {
                    abortTransactionAndroid()
                    alreadyAborted = true
                } else {
                    paramsContinua.continueCommand = STOP_TEF_COMMAND
                }
            }

            if (Util.isAndroidMode()) {
                if (toContinue) {
                    let lastMessage = TefMessageController.getLastMessage()
                    if (lastMessage != null) {
                        TefMessageController.clearLastMessage()
                        lastMessage = JSON.parse(lastMessage)
    
                        paramsContinua.command = lastMessage.command
                        paramsContinua.fieldType = lastMessage.fieldId
                        paramsContinua.minSize = lastMessage.minLength
                        paramsContinua.maxSize = lastMessage.maxLength
                    }
                    
                    let continueResult = window.Android.continueTransaction(paramsContinua.bufferParam, resetTimeout)
                    setTimeout(() => Util.logComunication('Android Continue TEF', paramsContinua.bufferParam, continueResult), 0)
                    resetTimeout = false
                    continueResult = JSON.parse(continueResult)
    
                    if (continueResult.message.stage === 2) {
                        androidSecondStage = true
                    }
    
                    if (!continueResult.error && continueResult.result === 0) {
                        if (continueResult.message.type === 'onTransactionResult') {
                            if (continueResult.message.resultCode === 0) {
                                androidSecondStage = false
                                return {
                                    'error': false,
                                    'finishedTransaction': true
                                }
                            } else {
                                let hasResultCode = continueResult.message && continueResult.message.resultCode != null
                                let resultCode = hasResultCode ? continueResult.message.resultCode : null
                                androidSecondStage = false
                                return tefErrorAndroid(errorMessage, resultCode)
                            }
                        } else {
                            retornoContinua = convertAndroidTefMessageIntoCommonTefMessage(continueResult.message)
                            // bufferConvertedbkp = retornoContinua.bufferConverted
                            bufferConvertedbkp = String(retornoContinua.bufferConverted)
                            if (continueResult.timeoutReached) {
                                stopTransactionTef()
                                ignoreMessage = true
                                PaymentController.clearDigitalWallet()
                            }
                        }
                    } else {
                        abortTransactionAndroid()
                        return {
                            error: true,
                            finishedTransaction: false,
                            retornoDll: continueResult.result
                        }
                    }
                }
            } else {
                if (toContinue) {
                    paramsContinua.sizeBuffer = bufferParam.length || 300
                    retornoContinua = await requesModule.curlRequest(EVENT_CONTINUA_TRANSACAO, paramsContinua)
                    setTimeout(() => {
                        Util.logComunication('Web Continue TEF', paramsContinua.bufferParam, retornoContinua)
                    })
                
                    // Destructuring + spread (ainda mais conciso)
                    const { bufferConverted, ...parsedResult } = JSON.parse(retornoContinua.data.result)
                    bufferConvertedbkp = structuredClone(bufferConverted)
                    retornoContinua = { ...parsedResult, bufferConverted }
                }
            }

            if (retornoContinua['retornoDll'] === 10000) {
                if (toContinue) {
                    result = continuaTransacaoTefOBJ.retornoContinuaTrad(retornoContinua, CDFILIAL = null, CDCAIXA = null, DATECANCEL, DOCNUMBER, valorTotal)
                }
                
                if (Util.isAndroidMode() && needToUpdateScreen(retornoContinua)) await Util.sleep(200)
                
                comando = retornoContinua['comando']
                tipoCampo = retornoContinua['tipoCampo']
                tamMinimo = retornoContinua['tamMinimo']
                tamMaximo = retornoContinua['tamMaximo']
                tamBuffer = (result && result.tamBuffer) || 300
                bufferParam = ''

                if (result !== undefined) {
                    if (result.sendBuffer) {
                        bufferParam = result.bufferMessage
                    }

                    // Previne os erros qua causam loop infinito na rotina de cancelamento de TEF
                    if (result.error && result.message) {
                        let invalidDate = result.message === 'Data Invalida'
                        let invalidNsu = result.message === 'Documento Invalido'
                        let invalidParcel = result.message === 'Numero de Parcelas Invalido'
                        if (invalidDate || invalidNsu || invalidParcel) {
                            Util.showInfoModal(result.message)
                            break
                        }
                    }
                }

                if (comando === 1) {
                    // Mensagem para o visor do operador
                    let message = bufferConvertedbkp || ''
                    eventModule.$emit('setTefMessage', message)
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // await Util.sleep(20)
                    bufferConvertedbkp = ''
                }
                /* if (comando === 2) {
                    // Mensagem para o visor do cliente
                    eventModule.$emit('setTefMessage', result.message)
                    if (Util.isAndroidMode()) await Util.sleep(200)
                } */
                if (comando === 3) {
                    // Mensagem para os dois visores
                    eventModule.$emit('setTefMessage', bufferConvertedbkp || '')
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // await Util.sleep(20)
                }
                if (comando === 4) {
                    let eventData = {
                        title: bufferConvertedbkp
                    }
                    eventModule.$emit('titleReceived', eventData)
                    titleReceived = bufferConvertedbkp
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // await Util.sleep(20)
                }
                if (comando === 11) {
                    // Deve remover a mensagem apresentada no visor do operador (comando 1)
                    eventModule.$emit('setTefMessage', '')
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // await Util.sleep(20)
                }
                /*
                if (comando === 12) {
                    // Deve remover a mensagem apresentada no visor do cliente (comando 2)
                    eventModule.$emit('setTefMessage', '')
                    if (Util.isAndroidMode()) await Util.sleep(200)
                } */
                if (comando === 13) {
                    // Deve remover mensagem apresentada no visor do operador e do cliente (comando 3)
                    eventModule.$emit('setTefMessage', '')
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // await Util.sleep(20)
                }
                if (comando === 14) {
                    /* let eventData = {
                        title: ''
                    }
                    eventModule.$emit('titleReceived', eventData)
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // await Util.sleep(20) */
                    titleReceived = ''
                }

                if (comando === 20 && isCancelTefOperation) {
                    // Por mais absurdo que pareça, de acordo com a doc do SiTef, 0 significa confirma e 1 signfica cancela
                    bufferParam = '0'
                } else if (comando === 20 && !ignoreMessage) {
                    let waitingForData = PaymentController.getWaitingForData()
                    let data = PaymentController.getCollectDataModalData()
                    if (data && data !== '') {
                        bufferParam = Util.deepCopy(data)
                        continueForData()
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                    } else if ((!data || data === '') && !waitingForData) {
                        eventModule.$emit('showCollectDataModal', { title: bufferConvertedbkp, type: 'dialog', minLength: 1, maxLength: 1 })
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                        waitForData()
                    } else if (waitingForData) {
                        await Util.sleep(500)
                    }
                } else {
                    bufferParam = '0'
                }

                if (comando === 21) {
                    if (isDigitalWalletPayment) {
                        // Nas operações de pagamento com carteira digital / PIX, pergunta ao usuário qual carteira deseja utilizar
                        if (!PaymentController.getDigitalWallet()) {
                            // so exibe as opções caso ja não esteja selecionada
                            eventModule.$emit('showWalletOptions')
                        }
                        bufferParam = PaymentController.getDigitalWallet()
                        if (Util.isAndroidMode()) await Util.sleep(200)
                    } else if (isFuncoesAdministrativas) {
                        // bufferParam = '0'
                        bufferParam = ''
                        if (!PaymentController.getFuncoesAdministrativasSelected() && !PaymentController.getWaitingForData()) {
                            PaymentController.setWaitingForData(true)
                            eventModule.$emit('showFuncoesAdministrativasOptions', bufferConvertedbkp)
                            if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // Util.sleep(200)
                            toContinue = false
                        } else if (!PaymentController.getFuncoesAdministrativasSelected() && PaymentController.getWaitingForData()) {
                            await Util.sleep(500)
                        } else {
                            bufferParam = PaymentController.getFuncoesAdministrativasSelected()
                            PaymentController.setFuncoesAdministrativasSelected('')
                            PaymentController.setWaitingForData(false)
                            toContinue = true
                            if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate() // Util.sleep(200)
                        }
                        
                    } else if (!isCancelTefOperation) {
                        // Nas operações de pagamento com cartão, sempre passa a opção 1
                        bufferParam = '1'
                    } else {
                        // Operações de cancelamento de TEF
                        // if (iterationCounter === 0) {
                            // Na primeira ocorrência do comando 21, é preciso verificar dinamicamente se a opção é
                            // 1 (DEBITO), 2 (CREDITO) ou 10 (PIX / CARTEIRA DIGITAL)
                            let waitingForData = PaymentController.getWaitingForData()
                            let data = PaymentController.getCollectDataModalData()
                            if (data && data !== '') {
                                bufferParam = Util.deepCopy(data)
                                continueForData()
                                if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                            } else if ((!data || data === '') && !waitingForData) {
                                eventModule.$emit('showCollectDataModal', { title: titleReceived, type: 'options', minLength: 1, maxLength: 10, options: bufferConvertedbkp })
                                if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                                waitForData()
                            } else if (waitingForData) {
                                await Util.sleep(500)
                            }
                            // iterationCounter++
                            // bufferParam = saleType
                        // } else {
                            // A partir da segunda iteração, é preciso abrir o menu para o usuário escolher uma opção
                           // eventModule.$emit('showCancelWalletOptions')
                            // eventModule.$emit('showFuncoesAdministrativasOptions', bufferConvertedbkp)
                            // if (Util.isAndroidMode()) await Util.sleep(200)
                            // bufferParam = PaymentController.getDigitalWallet()
                        // }
                    }
                }

                if (comando === 22) {
                    // 	Deve apresentar a mensagem em Buffer, e aguardar uma tecla do operador. É utilizada quando se deseja que o operador seja avisado de alguma mensagem apresentada na tela.
                    // eventModule.$emit('setTefMessage', result.message)
                    let waitingForData = PaymentController.getWaitingForData()
                    let data = PaymentController.getCollectDataModalData()
                    if (data && data !== '') {
                        bufferParam = Util.deepCopy(data)
                        continueForData()
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                    } else if ((!data || data === '') && !waitingForData) {
                        eventModule.$emit('showCollectDataModal', { title: bufferConvertedbkp, type: 'confirmation', minLength: 1, maxLength: 1 })
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                        waitForData()
                    } else if (waitingForData) {
                        await Util.sleep(500)
                    }
                }

                if (comando === 23) {
                    eventModule.$emit('toggleCancelButton', true)
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                } else if (lastCommand === 23) {
                    eventModule.$emit('toggleCancelButton', false)
                    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                }

                if (tipoCampo === 121 && isFuncoesAdministrativas) {
                    if (bufferConvertedbkp && bufferConvertedbkp !== '') {
                        await PaymentController.printComprovanteTef(bufferConvertedbkp)
                    } else {
                        Util.showInfoModal('Não foram recebidos dados para impressão do cancelamento')
                    }
                }
                if (tipoCampo === 122 && isFuncoesAdministrativas) {
                    if (bufferConvertedbkp && bufferConvertedbkp !== '') {
                        await PaymentController.printComprovanteTef(bufferConvertedbkp)
                    } else {
                        Util.showInfoModal('Não foram recebidos dados para impressão do cancelamento')
                    }
                }

                if (comando === 30 && tipoCampo === 514) {
                    /* Quando o usuario precisar informar dados durante o processo de coleta, nao continua ate ele terminar */
                    let waitingForData = PaymentController.getWaitingForData()
                    let data = PaymentController.getCollectDataModalData()
                    if (data && data !== '') {
                        data = data.replace(/[\/\W]/g, '')
                        bufferParam = Util.deepCopy(data)
                        continueForData()
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                    } else if ((!data || data === '') && !waitingForData) {
                        eventModule.$emit('showCollectDataModal', { title: bufferConvertedbkp, type: 'text', minLength: 1, maxLength: 3 })
                        waitForData()
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                    } else if (waitingForData) {
                        await Util.sleep(500)
                    }
                }
                if (comando === 30 && tipoCampo === 515) {
                    /* Quando o usuario precisar informar dados durante o processo de coleta, nao continua ate ele terminar */
                    let cancelData = PaymentController.getCancelTefData()
                    let dataCollect = PaymentController.getCollectDataModalData()
                    let waitingForData = PaymentController.getWaitingForData()
                    let data = (cancelData && cancelData.date) || dataCollect
                    if (data && data !== '') {
                        data = data.replace(/[\/\W]/g, '')
                        bufferParam = Util.deepCopy(data)
                        continueForData()
                    } else if ((!data || data === '') && !waitingForData) {
                        eventModule.$emit('showCollectDataModal', { title: bufferConvertedbkp, type: 'date', minLength: 4, maxLength: 8})
                        waitForData()
                        await waitForDOMUpdate.waitForDOMUpdate()
                    } else if (waitingForData) {
                        await Util.sleep(500)
                    }
                }
                if (comando === 30 && tipoCampo === 516) {
                    let cancelData = PaymentController.getCancelTefData()
                    let dataCollect = PaymentController.getCollectDataModalData()
                    let waitingForData = PaymentController.getWaitingForData()
                    let expectedNsuLength = parseInt(Util.getLocalConfigs('comprimentoNSU') || 0)
                    let nsu = (cancelData && cancelData.nsu) || dataCollect
                    if (process.env.NODE_ENV === 'production' && nsu.length < expectedNsuLength) {
                        let numberOfZeros = expectedNsuLength - nsu.length
                        for (let i = 0; i < numberOfZeros; i++) {
                            nsu = '0' + nsu
                        }
                    }
                    if (nsu && nsu !== '') {
                        bufferParam = Util.deepCopy(nsu)
                        continueForData()
                    } else if (!nsu && !waitingForData) {
                        eventModule.$emit('showCollectDataModal', { title: bufferConvertedbkp, type: 'text', minLength: 1, maxLength: 100 })
                        waitForData()
                        await waitForDOMUpdate.waitForDOMUpdate()
                    } else if (waitingForData) {
                        await Util.sleep(500)
                    }
                }
                if (comando === 30 && tipoCampo === 557) {
                    /* Quando o usuario precisar informar dados durante o processo de coleta, nao continua ate ele terminar */
                    /* Tipo de campo 517: CPF para consulta AVS */
                    /* let waitingForData = PaymentController.getWaitingForData()
                    let data = PaymentController.getCollectDataModalData()
                    if (data && data !== '') {
                        data = data.replace(/[\/\W]/g, '')
                        bufferParam = Util.deepCopy(data)
                        continueForData()
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                    } else if ((!data || data === '') && !waitingForData) {
                        eventModule.$emit('showCollectDataModal', { title: bufferConvertedbkp, type: 'cpf', minLength: 9, maxLength: 15 })
                        waitForData()
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                    } else if (waitingForData) {
                        await Util.sleep(500)
                    } */
                    bufferParam = '0'
                    comando = 0
                }
                if (comando === 34 && (tipoCampo === 146 || tipoCampo === 147)) {
                    // se cair aqui sem os parametros necessários, significa que esta tentando cancelar direto pelo menu administrativo, não é permitido
                    let params = PaymentController.getCancelTefData()
                    if (!params || !params.nsu || !params.date || !params.value) {
                        Util.showInfoModal('Cancelamento não permitido diretamente pelo menu administrativo')
                        stopTransactionTef()
                    } else {
                        bufferParam = params.value
                    }
                }

                continua = retornoContinua['continua']
            } else if (retornoContinua['retornoDll'] !== 0) {
                return {
                    error: true,
                    retornoDll: retornoContinua.retornoDll,
                    message: errorMessage
                }
            }
            bufferConvertedbkp = ''
        } while (retornoContinua['retornoDll'] === 10000)
        if (retornoContinua['retornoDll'] === 0) {
            return {
                'error': false,
                'finishedTransaction': true
            }
        } else {
            return continuaTransacaoTefOBJ.retornoDll(retornoContinua)
        }
    } catch (e) {
        Util.logComunication('Web Continue TEF', 'continuaTransacaoTef', e.stack)
        return {
            error: true,
            finishedTransaction: false,
            message: e.stack
        }
    }
}

const convertAndroidTefMessageIntoCommonTefMessage = (androidMessage) => {
    return  {
        bufferConverted: androidMessage.buffer,
        // tamBuffer,
        comando: androidMessage.command,
        tipoCampo: androidMessage.fieldId,
        tamMaximo: androidMessage.maxLength,
        tamMinimo: androidMessage.minLength,
        continua: 0,
        retornoDll: RETORNO_DLL_FAKE_ANDROID
    }
}

const tefErrorAndroid = (errorMessage, resultCode = null) => {
    let errorObject = {
        error: true,
        message: errorMessage
    }
    if (resultCode != null) errorObject.retornoDll = resultCode
    return errorObject
}

const abortTransactionAndroid = () => {
    let resAbort = window.Android.abortTransaction(STOP_TEF_COMMAND)
    Util.logComunication('Android Abort TEF', JSON.stringify(STOP_TEF_COMMAND), resAbort)
    resAbort = JSON.parse(resAbort)
}

const needToUpdateScreen = (retornoContinua) => {
    let isQrCodeMessage = retornoContinua.comando === 50 && retornoContinua.tipoCampo == 584
    let isRemoveQrCodeMessage = retornoContinua.comando === 51
    let isFooterMessage = retornoContinua.comando === 52

    return isQrCodeMessage || isRemoveQrCodeMessage || isFooterMessage
}

const stopTransactionTef = () => {
    cancelledByUser = true
    alreadyAborted = false
    PaymentTimeoutController.clear()
    PaymentController.setFuncoesAdministrativasSelected('')
    PaymentController.setWaitingForData(false)
    PaymentController.clearDigitalWallet()
    PaymentController.setCollectDataModalData(null)
    toContinue = true
}

function waitForData() {
    toContinue = false
    PaymentController.setCollectDataModalData(null)
    PaymentController.setWaitingForData(true)
}

function continueForData() {
    toContinue = true
    PaymentController.setCollectDataModalData(null)
    PaymentController.setWaitingForData(false)
}

export default {
    continuaTransacaoTef,
    stopTransactionTef
}



// WEBPACK FOOTER //
// ./src/assets/tef/MainTef.js